export default __webpack_public_path__ + "static/media/survivio-Ninja_Loadout-sm.cb3d8c90.gif";